import { useContext } from 'react';
import useSWR from 'swr';
import appContext from '../../../context/app/appContext';

const useSpoolsByRiskModel = (riskModelAddress: string) => {
    const { interfaceSDK } = useContext(appContext);

    const { data, error } = useSWR(
        interfaceSDK && riskModelAddress ? ['spoolsByRiskModel', riskModelAddress] : null,
        (_, riskModelAddress) => interfaceSDK?.get.getSpoolsByRiskModel(riskModelAddress)
    );

    return {
        spoolsByRiskModel: data,
        isLoading: !error && !data,
        error,
    };
};

export default useSpoolsByRiskModel;
